//#region import
import React, { useState } from "react";
import { Container, Row, Col, Button } from 'react-bootstrap';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { logout, selectFirebaseUser, selectEmailVerified, reset, resetStatus } from '_redux/slices/main-screen/user';
import { reset as HistoryReset } from '_redux/slices/assistance-bookings/bookings-history';
import { reset as TableReset } from '_redux/slices/prm-bookings/bookings-table';
import { reset as BookingsReset } from '_redux/slices/prm-bookings/bookings';
import { reset as CalendarReset } from '_redux/slices/prm-bookings/calendar';
import { reset as ScreenReset } from '_redux/slices/main-screen/render-screen';
import { reset as ReviewsReset } from '_redux/slices/analytics/reviews';
import { reset as RewardsReset } from '_redux/slices/prm-club/rewards';
import { reset as UserBookingsReset } from '_redux/slices/website/userbookings';
import { reset as resetWeather } from '_redux/slices/analytics/weather';

import { getAuth, sendEmailVerification } from 'firebase/auth';
import { useHistory } from 'react-router-dom';

// images
import unverifiedemail from "_assets/images/profile/timeline-unverified-email.png";
import verifiedEmail from "_assets/images/profile/timeline-verified-email.png";
//#endregion

const NotVerified = (props) => {
    //#region redux&history
    const dispatch = useDispatch();
    const firebaseUser = useSelector(selectFirebaseUser)
    const emailVerified = useSelector(selectEmailVerified)
    const history = useHistory();
    //#endregion

    const [emailSent, setEmailSent] = useState(false);


    //#region functionality logout,resend email
    // logout 
    const handleLogout = () => {
        // logout and change page
        dispatch(logout());
        history.push('/login');

        // reset all slices
        dispatch(resetStatus());
        dispatch(reset())
        dispatch(HistoryReset())
        dispatch(TableReset())
        dispatch(BookingsReset())
        dispatch(CalendarReset())
        dispatch(ScreenReset())
        dispatch(ReviewsReset())
        dispatch(RewardsReset())
        dispatch(UserBookingsReset())
        dispatch(resetWeather())
    }

    // resend email
    const resendEmailVerification = async () => {
        const currentUser = getAuth().currentUser;
        if (!currentUser) return;
        console.log('Sending verification email to:', currentUser.email);
        await sendEmailVerification(currentUser)
            .then((res) => { console.log('Verification email sent:', res); setEmailSent(true); })
            .catch((e) => console.error('Failed to send verification email:', e))
    }
    //#endregion

    return (
        <>
            <Row className='mt-5'>
                <Col xs={6}>

                    {/* Text */}
                    <Container>

                        {/* Title & Subtitle */}
                        <p style={{ fontSize: 46, fontWeight: 'bold' }}>Welcome, {firebaseUser ? '' + firebaseUser.displayName : ''}</p>

                        <p style={{ fontSize: 26, fontWeight: '200' }}>Your account has been successfully created and is now undergoing our verification process.</p>
                        {
                            !emailVerified ?
                                <p style={{ fontSize: 26, fontWeight: '200' }}>To continue to the next step of the authentication process, follow the link in the email that has been sent to you.</p>
                                :
                                <p style={{ fontSize: 26, fontWeight: '200' }}>Your email has been verified. Your account is currently waiting to be approved by an administrator.</p>
                        }

                    </Container>

                </Col>
                <Col className='mt-5'>
                    <Container className='mt-3'>
                        {
                            !emailVerified ?
                                <img
                                    src={unverifiedemail}
                                    width={650}
                                    style={{ marginTop: 100 }}
                                />
                                :
                                <img
                                    src={verifiedEmail}
                                    width={650}
                                    style={{ marginTop: 100 }}
                                />
                        }
                    </Container>

                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ marginLeft: 25 }}>
                        <p className='mt-5' style={{ fontSize: 26, fontWeight: 'bold' }}>Can't find the email?</p>
                        <p style={{ fontSize: 26, fontWeight: '200' }}>First, check your spam to see if the email was accidentally stored there.</p>
                        <Button variant='outline-primary' onClick={() => { resendEmailVerification() }} style={{ marginLeft: 0 }}>Resend Verification Email</Button>

                        <p className='mt-5' style={{ fontSize: 26, fontWeight: 'bold' }}>Email link expired?</p>
                        <p style={{ fontSize: 26, fontWeight: '200' }}>Our authentication links only stay valid for a short period of time as a security measure.</p>
                        <p style={{ fontSize: 26, fontWeight: '200' }}>Click the button below to resend a new email and restart the expiration period.</p>
                        <Button variant='outline-primary' onClick={() => { resendEmailVerification() }} style={{ marginLeft: 0 }}>Resend Verification Email</Button>
                        {emailSent && <p className='mt-2' style={{ fontSize: 16, color: 'green' }}>Verification email sent! Check your inbox.</p>}

                        <p className='mt-5' style={{ fontSize: 26, fontWeight: 'bold' }}>How does the verification process work?</p>
                        <p style={{ fontSize: 26, fontWeight: '200' }}>After creating your account, there is a two step process to verification, First, you must verify your email using the verification link sent to you. Next, your designated administrator will verify your account. Once both of these processes are completed you will have access to the portal</p>

                        <p className='mt-5' style={{ fontSize: 26, fontWeight: '400' }}>Having any issues?</p>
                        <div style={{ display: 'flex' }}>
                            <Button variant='outline-primary' onClick={() => { history.push({ pathname: '/contact', }); }}>Contact us</Button>
                            <Button style={{ marginLeft: 10 }} variant='outline-primary' onClick={handleLogout}>Log out</Button>
                        </div>
                    </div>
                </Col>

            </Row>
        </>
    )
}


export default NotVerified;